import { render, staticRenderFns } from "./OwnersFivesVacationsCreate.vue?vue&type=template&id=5503ac84&scoped=true&"
import script from "./OwnersFivesVacationsCreate.vue?vue&type=script&lang=js&"
export * from "./OwnersFivesVacationsCreate.vue?vue&type=script&lang=js&"
import style0 from "./OwnersFivesVacationsCreate.vue?vue&type=style&index=0&id=5503ac84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5503ac84",
  null
  
)

export default component.exports